import React from 'react'
import type { TF } from '../types'

const LABELS: Record<TF, string> = {
  '5': '5m', '15': '15m', '30': '30m', '60': '1h', '240': '4h', '720': '12h', 'D': '1D', 'W': '1W', 'M': '1M'
}

export default function TimeframeSelector({ value, onChange, className, tfs = ['5','15','30','60','240','720','D','W','M'] as TF[] }:{
  value: TF
  onChange: (tf: TF) => void
  className?: string
  tfs?: TF[]
}) {
  return (
    <div className={"flex flex-wrap items-center gap-1 " + (className || '')}>
      {tfs.map(tf => (
        <button key={tf} type="button" onClick={() => onChange(tf)}
          className={[
            'px-2 py-1 text-xs rounded-md border',
            value === tf ? 'border-primary text-primary bg-primary/10' : 'border-border text-foreground/80 hover:bg-muted/30'
          ].join(' ')}
        >{LABELS[tf]}</button>
      ))}
    </div>
  )
}

